import { Star, Flame, Check, Clock } from "lucide-react";

export function KeystoneStrip({ habits }) {
  const h = habits.find((x) => x.focus === "keystone");
  if (!h) {
    return (
      <div className="rounded-2xl border border-dashed border-amber-300 bg-amber-50/50 px-4 py-2.5 text-xs text-stone-600 flex items-center gap-2" data-testid="keystone-strip-empty">
        <Star className="w-3.5 h-3.5 text-amber-600" /> No Keystone habit yet — set one in “Habits &amp; focus” below to concentrate rewards and reminders.
      </div>
    );
  }
  const weekDone = h.week_count >= h.goal;
  return (
    <div className="rounded-2xl bg-stone-900 text-stone-100 px-4 sm:px-5 py-3 flex items-center gap-4 sm:gap-6 flex-wrap" data-testid="keystone-strip">
      <div className="flex items-center gap-2 min-w-0">
        <Star className="w-4 h-4 text-amber-300 fill-amber-300 shrink-0" />
        <div className="min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-widest text-amber-300">Keystone</div>
          <div className="font-display font-bold truncate" data-testid="keystone-strip-title">{h.title}</div>
        </div>
      </div>
      <div className="flex items-center gap-1.5" data-testid="keystone-strip-streak" title="Consecutive days">
        <Flame className={`w-4 h-4 ${h.streak > 0 ? "text-orange-400" : "text-stone-600"}`} />
        <span className="font-mono font-bold text-amber-300">{h.streak}</span>
        <span className="text-xs text-stone-400">day streak</span>
      </div>
      <div className="flex items-center gap-1.5" data-testid="keystone-strip-week" title="This week vs goal">
        <span className="font-mono font-bold text-amber-300">{h.week_count}/{h.goal}</span>
        <span className="text-xs text-stone-400">this week{weekDone ? " · goal met" : ""}</span>
      </div>
      <div className={`ml-auto inline-flex items-center gap-1 text-xs font-semibold ${h.completed_today ? "text-emerald-300" : "text-stone-400"}`} data-testid="keystone-strip-today">
        {h.completed_today ? <Check className="w-3.5 h-3.5" /> : <Clock className="w-3.5 h-3.5" />} {h.completed_today ? "Done today" : "Not yet today"}
      </div>
    </div>
  );
}
